<script>
  import store from './../../store/index.js';
  import mixinNotification from './Notif'
  const { VUE_APP_API_HOST } = process.env

  const defaultBot = {
    id: null,
    name: '',
    page: 0,
    topics: {
      theme: null,
      category: null,
      lang: 'fr'
    },
    hashtag: '',
    hashtagPrefix: '',
    inclusion: {
      tag: '',
      tags: []
    },
    exclusion: {
      tag: '',
      tags: []
    },
    blacklists: {
      tag: '',
      tags: []
    },
    sources: [],
    posts: {
      content: ['photo', 'video'],
      display: 'title',
      display_instagram: null,
      mode: 'standard',
      positionlink: 'in_posts',
      mixAutoPost: 0 
    },
    frequency: {
      custom: false,
      value: 60
    },
    utm: '',
    limit: 1,
    planning: {
      monday: null,
      tuesday: null,
      wednesday: null,
      thursday: null,
      friday: null,
      saturday: null,
      sunday: null
    },
    //sourceType: 'normal',
    sourceType: 'custom',
    whitelist: [],
    mentions: [],
    hashtagsAuto: [],
    instagram: {
      credentials: {
        username: null,
        password: null
      },
      layout: null
    },
    afterAutoPost : {
      retweetAuto: [],
      reshareAuto: [],
      repostAuto: []
    }
  }

  // eslint-disable-next-line
  const conversionTable = Object.freeze({
    // TODO
    // Local repr -> server repr
    id: 'id',
    name: 'name',
    page: 'page',
    'topics.theme.url': 'domain',
    'topics.category': 'category',
    'topics.lang': 'locale',
    hashtag: 'hashtag',
    blacklists: { // ?
      tag: '',
      tags: []
    },
    sources: [],
    posts: {
      content: ['photo', 'video'],
      display: 'title'
    },
    frequency: {
      custom: false,
      value: 60
    },
    utm: 'utm_source',
    limit: 'capping',
    status: 1
  })

  export default {

    mixins: [mixinNotification],

    data() {
      return { 
        defaultBot: { ...defaultBot },
      }
    },

    

    methods: {
      /**
       * Request headers/params for a mention/hashtag search, aware of the public demo
       * (store `demo/isActive`). In demo mode, sends the demo session header instead of a
       * Bearer token, and appends `&network=` (read from the fake page itself, see
       * store/modules/selectPage.js) so the backend can resolve which real demo page to use -
       * the frontend never sends a real page id (see engine's demoSession.js).
       * @param {string} pageId - the (possibly fake, in demo mode) page id used for this request
       * @returns {{headers: Object, networkParam: string}}
       */
      _demoRequestOptions(pageId) {
        if (!this.$store.getters['demo/isActive']) {
          return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, networkParam: '' }
        }

        const page = this.$store.getters['selectPage/selectPageAllPages'][pageId]
        const network = page && page.network

        return {
          headers: { 'X-Demo-Session': this.$store.getters['demo/sessionToken'] },
          networkParam: network ? `&network=${network}` : ''
        }
      },

      /**
       * Convert bot from LOCAL format to SERVER format.
       * @param {Object} bot - The bot at the LOCAL format
       * @returns {Object} - The bot at the SERVER format
       */
      // eslint-disable-next-line
      encode(bot) {
        // eslint-disable-next-line
        const serverBot = {}
      },

      /**
       * Convert bot from SERVER format to LOCAL format.
       * @param {Object} bot - The bot at the SERVER format
       * @return {Object} - The bot at the SERVER format
       */
      // eslint-disable-next-line
      decode(bot) {
        // eslint-disable-next-line
        const localBot = {}
      },

      searchSubCategories(theme, language) {
        return `${VUE_APP_API_HOST}/categories/search?type=${theme}&language=${language}&query=`
      },

      services(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/services`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      create(body) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/bots/`, body, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      createBot(body) {
        return this.$http
                   .post(`${VUE_APP_API_HOST}/bots/`, body, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      modify(bot) {
        return this.$http
                   .put(`${VUE_APP_API_HOST}/bots/${bot.id}`, bot, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      modifyBot(bot) {
        return this.$http
                   .put(`${VUE_APP_API_HOST}/bots/${bot.id}`, bot, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      get(body) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     },
                     { body }
                   )
                   .then(res => res, err => err)
      },
      getAllBots(body, minify=false) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots${minify ? '?minify=true' : ''}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     },
                     { body }
                   )
                   .then(res => res, err => err)
      },

      del(id) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/bots/${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },
      deleteBot(id) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/bots/${id}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getSlotsByBot(id) {
        return this.$http
                   .get(`${VUE_APP_API_HOST}/bots/${id}/slot`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      deleteSlotByBot(id, date) {
        return this.$http
                   .delete(`${VUE_APP_API_HOST}/bots/${id}/slot?date=${date}`, {
                     headers: {
                       Authorization: `Bearer ${localStorage.getItem('token')}`
                     }
                   })
                   .then(res => res, err => err)
      },

      getMentionsByApi(id, search, isUrl, notify = false, story = false) {
        if (this.$store.getters['postCreator/requestHisory']['mentions'][id] && this.$store.getters['postCreator/requestHisory']['mentions'][id][search]) return this.$store.getters['postCreator/requestHisory']['mentions'][id][search];
       
        const currentTime = Date.now();
        let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][id] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][id] > 600000
    
        search = encodeURIComponent(search)

        const { headers, networkParam } = this._demoRequestOptions(id)

        return this.$http.get(`${VUE_APP_API_HOST}/bots/mentions?id=${id}&search=${search}&url=${isUrl}&simulate=${needSimulate}&story=${story}${networkParam}`, {
            headers
        }).then(res => {
            this.$store.commit('postCreator/updateHistorySimulateRequest', {[id] : currentTime});
            this.$store.commit('postCreator/updateRequestHisory', {type: 'mentions', pageId : id, search, data: res.body});

            if (notify && res.body.error) {
              this.notify({
                title: 'Erreur',
                text: this.$t(res.body.error),
                color: 'danger',
                time: 10000,
                id: id
              })
            }
            return res.body
          }, 
          err => err
        )
      },
      
      getAvatarMentionByApi(id, mention) {
        const { headers, networkParam } = this._demoRequestOptions(id)

        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/bots/mentions/avatar?id=${id}&mention=${mention}${networkParam}`,
                     { headers }
                   )
                   .then(res => res, err => err)
      },

      getHashtagsByApi(id, search) {
        const currentTime = Date.now();
        let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][id] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][id] > 600000

        const { headers, networkParam } = this._demoRequestOptions(id)

        return this.$http.get(`${VUE_APP_API_HOST}/bots/hashtags?id=${id}&search=${search}&simulate=${needSimulate}${networkParam}`, {
          headers
        }).then(
          res => {
            this.$store.commit('postCreator/updateHistorySimulateRequest', {[id] : currentTime});
            return res
          }, 
          err => err
        )
      },

      getHighlightsInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/highlight`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      getUsernameInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/username`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },
      getAvatarInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/avatar`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      getInfoInstagram(params) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/pages/instagram/information`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                       params
                     },
                   )
                   .then(res => res, err => err)
      },

      twoFactorInstagramConnect(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/administration/proxies/connectapi`, params,
                     {
                      
                     },
                   )
                   .then(res => res, err => err)
      },

      twoFactorLinkedinConnect(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/bots/challenge/directapi`, params,
                     {
                      
                     },
                   )
                   .then(res => res, err => err)
      },

      connectLinkedinDirect(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/bots/connect/directapi`, params,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       },
                     },
                   )
                   .then(res => res, err => err)
      },

      twoFactorLinkedinResendCode(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/pages/conciergerie/resend`, params,
                     {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem('token')}`
                        },
                     },
                   )
                   .then(res => res, err => err)
      },

      checkTwoAuthApproval(params) {
        return this.$http
                   .post(
                     `${VUE_APP_API_HOST}/bots/check-approval/directapi`, params,
                     {

                     },
                   )
                   .then(res => res, err => err)
      },
    }
  }
</script>
